import { render, staticRenderFns } from "./AddCommentModal.vue?vue&type=template&id=1fd27342&scoped=true"
import script from "./AddCommentModal.vue?vue&type=script&lang=js"
export * from "./AddCommentModal.vue?vue&type=script&lang=js"
import style0 from "./AddCommentModal.vue?vue&type=style&index=0&id=1fd27342&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd27342",
  null
  
)

export default component.exports